import React from 'react';
import { Sparkles } from 'lucide-react';

export const PreferencesList = ({ preferences, compact = false, title = 'Preferenze cliente', testId = 'preferences-list' }) => {
  if (!preferences?.length) return null;
  return (
    <div className={`rounded-lg border border-accent/20 bg-accent/5 ${compact ? 'p-2 mt-2' : 'p-3'}`} data-testid={testId}>
      <p className={`font-semibold flex items-center gap-1.5 text-accent ${compact ? 'text-xs mb-1' : 'text-sm mb-2'}`}>
        <Sparkles className="h-3.5 w-3.5" /> {title}
      </p>
      <div className="space-y-1">
        {preferences.map((p) => (
          <div key={p.question_id} className={compact ? 'text-xs' : 'text-sm'} data-testid={`${testId}-item-${p.question_id}`}>
            <span className="text-muted-foreground">{p.emoji ? `${p.emoji} ` : ''}{p.question_label}</span>
            <p className="font-medium text-foreground break-words whitespace-pre-wrap">{p.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PreferencesList;
